import { useMemo, useState } from "react";
import AdminBtn from "../layout/AdminBtn";

const DEFAULT_BIBLIOTECAS_OPTIONS = {
  limit: 250,
  maxPages: 5,
  enrichDetails: true,
  matchVenues: true,
  dedupe: true,
  inferTags: true,
};

const CultureSourceRunNowModal = ({
  source,
  readinessPayload,
  isOpen,
  isRunning,
  onClose,
  onConfirm,
}) => {
  const [mode, setMode] = useState("dry_run");
  const [options, setOptions] = useState(DEFAULT_BIBLIOTECAS_OPTIONS);

  const isBibliotecas = source?.sourceKey === "BIBLIOTECAS_MEDELLIN_EVENTS";
  const canApplyReal =
    readinessPayload?.canApplyRealIngest === true ||
    source?.canApplyRealIngest === true;
  const applyBlockedReason = useMemo(() => {
    if (canApplyReal) {
      return null;
    }
    return (
      readinessPayload?.blockingReasons?.[0] ||
      source?.blockingReasons?.[0] ||
      "Real ingest is not available until env and enable requirements are met."
    );
  }, [canApplyReal, readinessPayload, source]);

  if (!isOpen || !source) {
    return null;
  }

  const handleSubmit = () => {
    onConfirm({
      dryRun: mode === "dry_run",
      apply: mode === "apply",
      ...options,
    });
  };

  const toggleOption = (key) => {
    setOptions((current) => ({ ...current, [key]: !current[key] }));
  };

  return (
    <div className="admin-re-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="admin-re-modal panel-card"
        role="dialog"
        aria-labelledby="culture-run-now-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="admin-re-modal-header">
          <div>
            <p className="eyebrow">Run Now</p>
            <h2 id="culture-run-now-modal-title">{source.sourceName}</h2>
            <p className="muted admin-re-source-code">{source.sourceKey || source.sourceCode}</p>
          </div>
          <button type="button" className="midpoint-share-button" onClick={onClose}>
            Close
          </button>
        </header>

        <div className="admin-re-modal-body">
          <fieldset className="culture-run-now-mode">
            <legend className="muted">Run mode</legend>
            <label>
              <input
                type="radio"
                name="run-mode"
                value="dry_run"
                checked={mode === "dry_run"}
                onChange={() => setMode("dry_run")}
              />
              Dry-run (no DB writes)
            </label>
            <label>
              <input
                type="radio"
                name="run-mode"
                value="apply"
                checked={mode === "apply"}
                disabled={!canApplyReal}
                onChange={() => setMode("apply")}
              />
              Real ingest (limited apply)
            </label>
          </fieldset>

          {mode === "apply" && !canApplyReal ? (
            <p className="admin-data-health-error">{applyBlockedReason}</p>
          ) : null}

          {isBibliotecas ? (
            <div className="culture-run-now-options">
              <label>
                Limit
                <input
                  type="number"
                  min="1"
                  max="250"
                  value={options.limit}
                  onChange={(event) =>
                    setOptions((current) => ({
                      ...current,
                      limit: Number(event.target.value) || DEFAULT_BIBLIOTECAS_OPTIONS.limit,
                    }))
                  }
                />
              </label>
              <label>
                Max pages
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={options.maxPages}
                  onChange={(event) =>
                    setOptions((current) => ({
                      ...current,
                      maxPages: Number(event.target.value) || DEFAULT_BIBLIOTECAS_OPTIONS.maxPages,
                    }))
                  }
                />
              </label>
              {[
                ["enrichDetails", "Enrich details"],
                ["matchVenues", "Match venues"],
                ["dedupe", "Dedupe"],
                ["inferTags", "Infer tags"],
              ].map(([key, label]) => (
                <label key={key}>
                  <input
                    type="checkbox"
                    checked={options[key]}
                    onChange={() => toggleOption(key)}
                  />
                  {label}
                </label>
              ))}
            </div>
          ) : null}

          {source.warnings?.length ? (
            <ul className="culture-readiness-detail-list">
              {source.warnings.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          ) : null}

          <div className="admin-re-modal-header__actions">
            <AdminBtn variant="ghost" onClick={onClose} disabled={isRunning}>
              Cancel
            </AdminBtn>
            <AdminBtn
              variant="primary"
              onClick={handleSubmit}
              disabled={isRunning || (mode === "apply" && !canApplyReal)}
            >
              {isRunning ? "Running…" : mode === "apply" ? "Run real ingest" : "Run dry-run"}
            </AdminBtn>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CultureSourceRunNowModal;
